<template>
  <scheduled-event-form :template-data="template" />
</template>

<script>
import ScheduledEventForm from 'VueComponents/ScheduledEventForm';

export default {
  components: {
    ScheduledEventForm,
  },
  computed: {
    template() {
      return window.template;
    },
  },
};
</script>
